"use client";

import { useState } from "react";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import type { PageAiFeaturesSchema } from "@/sanity/pages/PageAiFeaturesTemplate";
import { SectionHeading } from "./ui";
import styles from "./ai-features.module.scss";

export default function FAQSection({
  data,
}: {
  data?: PageAiFeaturesSchema["faq"];
}) {
  const [open, setOpen] = useState<string | null>(
    data?.questions?.find((item) => item.answer?.length)?._key ?? null,
  );
  if (!data) return null;
  return (
    <section className={styles.faq}>
      <div className={styles.faqHeading}>
        <SectionHeading data={data} align="left" />
      </div>
      <div className={styles.questions}>
        {data.questions?.map((item, i) => {
          const hasAnswer = Boolean(item.answer?.length);
          const expanded = hasAnswer && open === item._key;
          return (
            <div
              key={item._key}
              className={styles.faqItem}
              data-open={expanded}
            >
              <button
                type="button"
                aria-expanded={expanded}
                aria-controls={hasAnswer ? `coach-faq-${item._key}` : undefined}
                disabled={!hasAnswer}
                onClick={() => setOpen(expanded ? null : item._key)}
              >
                <span>
                  <span className={styles.faqNumber}>{i + 1}. </span>
                  {item.question}
                </span>
                <span className={styles.faqArrow} aria-hidden="true" />
              </button>
              {hasAnswer && (
                <div
                  id={`coach-faq-${item._key}`}
                  aria-hidden={!expanded}
                  className={styles.faqAnswerReveal}
                >
                  <div className={styles.faqAnswer}>
                    <span aria-hidden="true">↳</span>
                    <div>
                      <PortableText
                        value={item.answer!}
                        components={richTextComponent}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className={styles.wordmark} aria-hidden="true">
        <span>TS</span>
        <small>
          <span className={styles.builtToWin}>BUILT TO WIN</span>
          <span className={styles.wordmarkYear}>
            20
            <i />
            26
          </span>
        </small>
        <span className={styles.logoGrid}>
          {Array.from({ length: 25 }, (_, i) => (
            <i key={i} />
          ))}
        </span>
      </div>
    </section>
  );
}
